import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const contentArray = [
  {
    title: 'Welcome to Our Global Team',
    description: 'Connecting talent from around the world to create extraordinary solutions',
    buttonText: 'Join Our Journey',
    backgroundImage: './assets/imgcarousal02.png',
  },
  {
    title: 'Innovate with Us',
    description: 'Building the future with cutting-edge technology and diverse expertise',
    buttonText: 'Explore Now',
    backgroundImage: './assets/imgcarousal01.png',
  },
  {
    title: 'Collaborate Globally',
    description: 'Join a network of professionals driving impactful change worldwide',
    buttonText: 'Get Involved',
    backgroundImage: './assets/imgcarousal03.png',
  },
];

const HomeNewNew: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    // Preload images to prevent loading delays
    contentArray.forEach((item) => {
      const img = new Image();
      img.src = item.backgroundImage;
    });

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % contentArray.length);
    }, 5000); // Change every 5 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  const currentContent = contentArray[currentIndex];

  return (
    <section className="min-h-screen text-white py-20 content-center relative overflow-hidden">
      {/* Background Image with Crossfade */}
      <AnimatePresence initial={false}>
        <motion.div
          key={currentIndex}
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url('${currentContent.backgroundImage}')` }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.5, ease: 'easeInOut' }}
        />
      </AnimatePresence>
      <motion.div
        className="absolute bottom-24 right-6 md:bottom-12 md:right-12 w-32 h-32 md:w-40 md:h-40 bg-gradient-to-br from-red-500 to-orange-500 flex items-center justify-center text-center p-4 shadow-lg z-45"
        animate={{
          scale: [1, 1.05, 1],
          transition: { duration: 2, repeat: Infinity, ease: 'easeInOut' },
        }}
        style={{ borderRadius: '64% 36% 70% 30% / 69% 60% 40% 31% ' }}
      >
        <motion.div
          className="absolute inset-0  border-2 border-white/50"
          animate={{ rotate: 360 }}
          transition={{ duration: 10, repeat: Infinity, ease: 'linear' }}
          style={{ borderRadius: '64% 36% 70% 30% / 69% 60% 40% 31% ' }}
        />
        <p className="text-xs md:text-sm font-semibold text-white">
          Unite. Innovate. Succeed.
        </p>
      </motion.div>
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r " />
      <div className="relative z-40 flex flex-col h-full transition-all duration-500 bg-gradient-to-t from-[#a3582a58] to-white" />
      <div className="absolute bottom-10 items-center flex justify-content-center  md:bottom-8 left-3 md:left-8 w-full h-96 md:w-52 md:h-72 z-30 opacity-90  ">
        <video
          className="w-1/2 md:w-full md:h-full h-3/4  backdrop-blur-lg  object-cover rounded-lg shadow-lg "
          autoPlay
          loop
          muted
          playsInline
        >
          <source src="./assets/trios_canva_mobile.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      {/* <div
        className="container mx-auto px-4 text-center relative z-50 bg-[#00000054]
        p-3  max-w-[700px]  rounded-lg " >
       
        <AnimatePresence mode="wait">
          <motion.div
            key={currentIndex}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.5, ease: 'easeInOut' }}
          >
            <h1 className="text-5xl font-bold mb-4">{currentContent.title}</h1>
            <p className="text-xl mb-8">{currentContent.description}</p>
            <button className="bg-gradient-to-r from-red-500 to-orange-500 text-[#edd9ccf4] px-6 py-3 rounded-full font-semibold hover:bg-blue-100 transition">
              {currentContent.buttonText}
            </button>
          </motion.div>
        </AnimatePresence>
      </div> */}

    </section>
  );
};

export default HomeNewNew;